import React from 'react';
import styles from './styles/infobar.module.css';
import { Icon } from '../icon/icon';
export const InfobarIcon = ({
  icon
}) => {
  if (!icon) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.icon,
    "data-testid": "infobar-icon"
  }, /*#__PURE__*/React.createElement(Icon, {
    width: 24,
    height: 24
  }, icon));
};